<template>
  <div class="container" id="pageMockLogs" style="padding-top: 0px">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex class="ml-3" sm12>
          <h2>Minhas provas</h2>
          <div class="subtitle-1">
            Cadastre ou atualize o resultado de suas provas para que possamos te
            acompanhar.
          </div>
        </v-flex>
      </v-layout>
      <v-data-table
        :headers="headers"
        :items="exams_to_table"
        :items-per-page="15"
        class="elevation-0"
        :loading="loading"
        loading-text="Carregando... Por favor, aguarde"
      >
        <template #item.actions="{ item }">
          <div>
            <v-tooltip top>
              <span>Delete uma prova</span>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  @click="deleteExam(item)"
                  style="cursor: pointer"
                  small
                  class="mr-2"
                >
                  delete
                </v-icon>
              </template>
            </v-tooltip>

            <v-icon
              @click="start_edit(item)"
              style="cursor: pointer"
              small
              class="mr-2"
            >
              edit
            </v-icon>
          </div>
        </template>
        <template v-slot:top>
          <v-toolbar flat>
            <v-spacer></v-spacer>
            <v-btn
              @click="add_dialog = true"
              color="primary"
              dark
              rounded
              elevation="0"
              class="mb-2"
            >
              Cadastrar prova
            </v-btn>
          </v-toolbar>
        </template>
      </v-data-table>
      <v-dialog
        v-model="add_dialog"
        max-width="410"
        content-class="dialog-class"
      >
        <v-card class="rounded-xl">
          <v-card-title>Adicionando Prova</v-card-title>

          <div class="px-6 ga-3 flex-column">
            <div class="d-flex align-center justify-space-between mb-5 mt-3">
              <span>Data da prova</span>
              <v-menu
                :close-on-content-click="true"
                transition="scale-transition"
                offset-y
                rounded
                full-width
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on" class="ls-outlined">
                    {{
                      !new_exam_date
                        ? "- - / - - / - -"
                        : new Intl.DateTimeFormat("pt-BR", {
                            day: "numeric",
                            year: "numeric",
                            month: "short",
                            timeZone: "America/Sao_Paulo",
                          }).format(
                            new Date(
                              new_exam_date.split("-")[0],
                              new_exam_date.split("-")[1] - 1,
                              new_exam_date.split("-")[2].split(" ")[0],
                            ),
                          )
                    }}
                  </div>
                </template>
                <v-date-picker
                  outlined
                  locale="pt-br"
                  min="1950-01-01"
                  :value="new_exam_date"
                  no-title
                  @change="(val) => (new_exam_date = val)"
                >
                </v-date-picker>
              </v-menu>
            </div>
            <div class="d-flex align-center justify-space-between mb-5">
              <span>Hora da prova</span>
              <div @click="add_time_dialog = true" class="ls-outlined">
                {{
                  !new_exam_time
                    ? "- - : - -"
                    : new_exam_time.split(":")[0] +
                      ":" +
                      new_exam_time.split(":")[1]
                }}
              </div>
              <v-dialog
                width="290px"
                v-model="add_time_dialog"
                @click:outside="add_time_dialog = false"
              >
                <v-time-picker
                  format="24hr"
                  locale="pt-br"
                  v-model="new_exam_time"
                  @change="add_time_dialog = false"
                >
                </v-time-picker>
              </v-dialog>
            </div>

            <div class="d-flex align-center justify-space-between mb-3">
              <span>Certificação</span>
              <v-spacer></v-spacer>
              <v-select
                outlined
                dense
                :items="certifications"
                style="max-width: 148px"
                hide-details
                item-text="name"
                item-value="id"
                v-model="new_exam_certification"
                label="Certificação"
              >
              </v-select>
            </div>
          </div>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              class="mb-3 mr-2 px-5 width-btn"
              elevation="0"
              rounded
              dark
              :loading="add_loading"
              @click="add_prova()"
            >
              Adicionar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- dialog for editing items -->
      <v-dialog
        v-model="edit_dialog"
        max-width="410"
        content-class="dialog-class"
      >
        <v-card class="rounded-xl">
          <v-card-title>Editar Prova</v-card-title>
          <div class="px-6 ga-3 flex-column">
            <div class="d-flex align-center justify-space-between mb-5 mt-3">
              <span>Data da prova</span>
              <div @click="edit_date_dialog = true" class="ls-outlined">
                {{
                  !edit_exam_date
                    ? "--/--/--"
                    : new Intl.DateTimeFormat("pt-BR", {
                        day: "numeric",
                        year: "numeric",
                        month: "short",
                        timeZone: "America/Sao_Paulo",
                      }).format(
                        new Date(
                          edit_exam_date.split("-")[0],
                          edit_exam_date.split("-")[1] - 1,
                          edit_exam_date.split("-")[2].split(" ")[0],
                        ),
                      )
                }}
              </div>
              <v-dialog
                width="290px"
                v-model="edit_date_dialog"
                @click:outside="edit_date_dialog = false"
              >
                <v-date-picker
                  locale="pt-br"
                  min="1950-01-01"
                  :value="edit_exam_date"
                  no-title
                  @change="
                    (val) => {
                      edit_exam_date = val;
                      edit_date_dialog = false;
                    }
                  "
                >
                </v-date-picker>
              </v-dialog>
            </div>
            <div class="d-flex align-center justify-space-between mb-5">
              <span>Hora da prova</span>
              <div @click="edit_time_dialog = true" class="ls-outlined">
                {{
                  !edit_exam_time
                    ? "--:--"
                    : edit_exam_time.split(":")[0] +
                      ":" +
                      edit_exam_time.split(":")[1]
                }}
              </div>
              <v-dialog
                width="290px"
                v-model="edit_time_dialog"
                @click:outside="edit_time_dialog = false"
              >
                <v-time-picker
                  format="24hr"
                  locale="pt-br"
                  v-model="edit_exam_time"
                  @change="edit_time_dialog = false"
                >
                </v-time-picker>
              </v-dialog>
            </div>
            <div class="d-flex align-center justify-space-between mb-5">
              <span>Nota</span>
              <v-text-field
                outlined
                dense
                hide-details
                style="max-width: 148px"
                label="Sua nota"
                type="number"
                v-model="edit_exam_grade"
              ></v-text-field>
            </div>
            <div class="d-flex align-center justify-space-between mb-5">
              <span>Status da Aprovação</span>
              <div @click="change_approved" style="cursor: pointer">
                {{ edit_exam_approved_string }}
              </div>
            </div>
          </div>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              class="mb-3 px-5 width-btn"
              elevation="0"
              rounded
              dark
              :loading="edit_loading"
              @click="edit_prova()"
            >
              Editar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import UserExams from "../../services/userExams.service";
import CertificationService from "../../services/certifications.service";
export default {
  metaInfo: {
    title: "LS",
    titleTemplate: "%s - Meus Cursos",
    htmlAttrs: {
      lang: "pt-br",
      amp: false,
    },
  },
  data() {
    return {
      add_time_dialog: false,
      new_exam_certification: "",
      new_exam_date: "",
      new_exam_time: "",
      add_loading: false,
      add_dialog: false,

      edit_time_dialog: false,
      edit_date_dialog: false,
      edit_dialog: false,
      edit_exam_id: "",
      edit_exam_date: "",
      edit_exam_time: "",
      edit_exam_grade: "",
      edit_exam_status: 0,
      edit_loading: false,

      loading: true,
      certifications: [],
      exams: [],
      headers: [
        {
          text: "Certificação",
          align: "start",
          sortable: false,
          value: "certification",
        },
        {
          text: "Data",
          value: "date",
          sortable: false,
        },
        {
          text: "Nota",
          value: "grade",
        },
        {
          text: "Resultado",
          value: "approved_string",
        },
        {
          text: "Ações",
          value: "actions",
          sortable: false,
        },
      ],
    };
  },
  async mounted() {
    const { data } = await CertificationService.getCertifications();
    this.certifications = data;

    await this.loadExam();
    // get the url params
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get("id");
    if (id) {
      const exam = this.exams_to_table.find((exam) => exam.id == id);
      if (exam === undefined) {
        // show error
        window.getApp.sendSnackMessage(
          'Nenhuma prova encontrada com esse "id".',
          "error",
        );
        return;
      }
      this.start_edit(exam);
    }
  },
  watch: {
    // on dialog close we reset the form
    edit_dialog(val) {
      if (val === false) {
        this.reset_edit_form();
      }
    },
  },
  methods: {
    change_approved() {
      // switch case to change the status, possible 0 1
      switch (this.edit_exam_status) {
        case 0:
          this.edit_exam_status = 1;
          break;
        case 1:
          this.edit_exam_status = 0;
          break;
        default:
          this.edit_exam_status = 0;
          break;
      }
    },
    reset_edit_form() {
      this.edit_exam_grade = "";
      this.edit_exam_date = "";
      this.edit_exam_time = "";
      this.edit_exam_id = "";
      this.edit_exam_status = 0;
    },
    getHM(time) {
      if (!time) return time;
      return time.split(":")[0] + ":" + time.split(":")[1];
    },
    async edit_prova() {
      this.edit_loading = true;
      // if there is any field empty, show error
      if (!this.edit_exam_date || !this.edit_exam_time) {
        window.getApp.sendSnackMessage(
          "Os campos DATA DA PROVA e HORA DA PROVA são obrigatórios",
          "error",
        );
        this.edit_loading = false;
        return;
      }

      if (this.exam_date) {
        if (!this.edit_exam_grade || this.edit_exam_status === null) {
          window.getApp.sendSnackMessage(
            "Os campos NOTA e STATUS APROVAÇÃO são obrigatórios",
            "error",
          );
          this.edit_loading = false;
          return;
        }
      }
      try {
        await UserExams.updateExam(
          this.edit_exam_date,
          this.getHM(this.edit_exam_time),
          this.edit_exam_grade,
          this.edit_exam_status,
          this.edit_exam_id,
        );
        window.getApp.sendSnackMessage("Prova editada com sucesso", "success");
      } catch (error) {
        window.getApp.sendSnackMessage(error.message, "error");
        this.edit_loading = false;
        return;
      }
      this.reset_edit_form();

      this.edit_loading = false;

      this.edit_dialog = false;
      this.loadExam();
    },
    start_edit(item) {
      this.edit_dialog = true;
      console.log(item);
      this.edit_exam_grade = item.grade;
      this.edit_exam_id = item.id;

      if (item.date) {
        const [date, time] = item.date.split(" ");

        let reversed_date = date
          .replace(",", "")
          .split("/")
          .reverse()
          .join("-");
        this.edit_exam_date = reversed_date;
        this.edit_exam_time = time;
      }

      this.edit_exam_status = item.approved;
    },
    async add_prova() {
      this.add_loading = true;
      // if there is any field empty, show error
      if (
        !this.new_exam_certification ||
        !this.new_exam_date ||
        !this.new_exam_time
      ) {
        window.getApp.sendSnackMessage("Preencha todos os campos", "error");
        this.add_loading = false;
        return;
      }
      try {
        await UserExams.addExam(
          this.new_exam_date,
          this.new_exam_time,
          this.new_exam_certification,
        );
        window.getApp.sendSnackMessage(
          "Prova adicionada com sucesso",
          "success",
        );
      } catch (error) {
        window.getApp.sendSnackMessage(error.message, "error");
        this.new_exam_certification = "";
        this.add_loading = false;
        return;
      }

      this.add_loading = false;

      this.new_exam_certification = "";
      this.new_exam_date = "";
      this.new_exam_time = "";

      this.add_dialog = false;
      this.loadExam();
    },
    async deleteExam(item) {
      this.loading = true;
      try {
        await UserExams.deleteExam(item.id);
      } catch (error) {
        console.log(error);
      }
      await this.loadExam();
    },
    async loadExam() {
      this.loading = true;
      try {
        const { data } = await UserExams.getMyExams();
        this.exams = data;
      } catch (error) {
        console.log(error);
      }
      this.loading = false;
      return;
    },
    status_to_approved_string(status) {
      // switch case for true and false
      switch (status) {
        case 1:
          return "Aprovado";
        case 0:
          return "Reprovado";
        case null:
          return "Pendente";
      }
    },
  },
  computed: {
    edit_exam_approved_string() {
      return this.status_to_approved_string(this.edit_exam_status);
    },
    exams_to_table() {
      return this.exams.map((exam) => {
        return {
          approved: exam.approved,
          approved_string: this.status_to_approved_string(exam.approved),
          certification: this.certifications.find(
            (cert) => cert.id === exam.certification_id,
          ).name,
          date: exam.exam_date
            ? new Date(exam.exam_date).toLocaleString("pt-BR")
            : "",
          grade: exam.score,
          actions: null,
          id: exam.id,
          raw_exam: exam,
        };
      });
    },
  },
};

/**
     * approved: 0
        certification: {id: 1, name: 'teste cert', description: 'teste', minimum_score: 60, issuing_institution_id: 1, …}
        certification_id: 1
        exam_date: "2023-03-13 00:00:00"
        id: 6
        score: null
        user_id: 56732
     */
</script>

<style lang="scss">
#pageMockLogs {
  max-width: 900px !important;
}
.main {
  min-height: calc(100vh - 96px);
  display: flex;
  align-items: center;
  justify-content: center;
}
.dialog-class {
  border-radius: 25px !important;
}
.ls-outlined {
  border: 1px solid grey;
  border-radius: 4px;
  padding: 6px 10px;
  cursor: pointer;
  min-width: 148px;
  text-align: center;
}
.width-btn {
  min-width: 148px !important;
  @media (max-width: 500px) {
    width: 100%;
  }
}
</style>
